import React from 'react'
import { withRouter } from 'react-router'

import Description from './abstract/Description'
import Window from '../../../../../common/Window'

class Description1 extends Description {
  render () {
    const SekkeiUnitPriceSetting = this.getSetting('SekkeiUnitPriceSetting')
    const GetsugakuSetting = this.getSetting('GetsugakuSetting')
    if (SekkeiUnitPriceSetting && GetsugakuSetting) {
      return (
        <div className='kw-description'>

          <p>１．「型枠大工の報酬月額」「型枠解体工の報酬月額」の用語の定義</p>
          <table>
            <tbody>
              <tr>
                <th>①日額手取り賃金</th>
                <td>技能者の報酬日額（社会保険料の本人負担分を含まない）</td>
              </tr>
              <tr>
                <th>②日額賃金（本人負担含む）</th>
                <td>技能者の報酬日額（社会保険料の本人負担分を含む）</td>
              </tr>
              <tr>
                <th>③公共工事設計労務単価</th>
                <td>{this.getWareki(SekkeiUnitPriceSetting.startMonth)}から適用される都道府県ごとの型枠大工の公共工事設計労務単価。国土交通省及び農林水産省が公共工事の積算に用いる。</td>
              </tr>
              <tr>
                <th>④法定福利費込み日額人件費</th>
                <td>技能者の報酬日額（社会保険料の本人負担分を含む）に、雇用主の負担する法定福利費の日額（法定福利費を平均日数で除した額）を加えた額</td>
              </tr>
              <tr>
                <th>⑤平均労務日数</th>
                <td>当該工事で月に就労する平均の日数</td>
              </tr>
              <tr>
                <th>⑥労務月額</th>
                <td>
                  ①～④の中から選択した日額単価（※）に平均労務日数を掛けた額<br />
                  ※①の場合は社会保険料の本人負担分を加えた額<br />
                  ※④の場合は法定福利費の日額を除いた額<br />
                  ※②、③の場合は②又は③の額そのもの
                </td>
              </tr>
              <tr>
                <th>⑦標準報酬月額</th>
                <td>労務月額を、法定の等級区分に基づき、保険料算出基準となる標準月額に換算したもの（厚生年金保険法第20条）</td>
              </tr>
            </tbody>
          </table>

        </div>
      )
    } else {
      Window.alert('対象見積書作成日時点の初期値データが登録されていません。\n日本型枠工事業協会へご連絡ください。', () => {
        this.props.history.push('/company_user/estimation/' + this.props.estimationType)
        Window.closeDialog()
      })
      return (
        <div>-</div>
      )
    }
  }
}
export default withRouter(Description1)



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/EstimationEdit/LaborUnitPriceTab/Description1.js